import useWorkflowTriggersKeyValueData from "#src/hooks/useWorkflowTriggersKeyValueData";
import { KeyValuePanel } from "@validereinc/common-components";
import { type WorkflowType } from "@validereinc/domain";
import React from "react";

/**
 * Renders workflow trigger metadata (form, asset, or workflow completion) as key–value panels.
 */
export const WorkflowTriggerKeyValuePanel = ({
  workflowDetails,
}: {
  workflowDetails?: WorkflowType;
}) => {
  const { trigger, formTriggerDetails, isLoading } =
    useWorkflowTriggersKeyValueData(workflowDetails);

  if (trigger.length + formTriggerDetails.length === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "20px",
      }}
    >
      <KeyValuePanel
        panelMaxColumnCount={1}
        panelKeyValueListProps={{
          variant: "shaded",
        }}
        panelProps={{
          title: "Trigger Details",
          isFluidY: true,
          loaded: Boolean(workflowDetails) || isLoading,
          style: { flexGrow: 1 },
        }}
        data={trigger}
      />
      {formTriggerDetails.length > 0 && (
        <KeyValuePanel
          panelMaxColumnCount={1}
          panelProps={{
            title: "Triggering Form Questions & Answers",
            isFluidY: true,
            loaded: Boolean(workflowDetails) || isLoading,
            style: { flexGrow: 1 },
          }}
          data={formTriggerDetails}
          panelKeyValueListProps={{
            variant: "shaded",
          }}
        />
      )}
    </div>
  );
};
